import React from 'react';
import TileSkeleton from '../TileSkeleton';
import './gridSkeleton.css';

interface DynamicLobbyListSkeletonProps {
  count?: number;
}

const GridSkeleton = ({ count = 18 }: DynamicLobbyListSkeletonProps) => (
  <div className="dynamicLobby__skeleton-viewAllGrid">
    {Array.from({ length: count }).map((_, i: number) => (
      // eslint-disable-next-line react/no-array-index-key -- list is static
      <TileSkeleton className="dynamicLobby__skeleton-viewAllSlotTile" key={`image_${i}`} />
    ))}
  </div>
);

export default GridSkeleton;
